<template>
  <div class="errorcon">
    <img src="static/img/link.png" />
    <span>链接错误</span>
  </div>
</template>
<script>
export default {
  name: 'NotFound',
  data() {
    return {}
  }
}
</script>
<style scoped>
.errorcon {
  background: #fff;
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 24px;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.errorcon img {
  width: 60px;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/NotFound.vue